import React from 'react';
import { string } from 'prop-types';
import { css } from '@emotion/css';

import { decimalFormat } from '@ajaibid/utils';
import { colors, Container, OverlayTrigger, Tooltip, Typography } from '@ajaibid/components';
import SvgIcon from '@/components/SvgIcon';

import stockService from '@/services/stock';

const styTitle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  margin-bottom: 8px;
`;

const styContainer = css`
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 8px 16px;
  border: 1px solid ${colors.NEUTRAL_2};
  border-radius: 8px;

  > div:first-child {
    padding-right: 16px;
    border-right: 0.5px solid ${colors.NEUTRAL_2};
  }
  > div:last-child {
    padding-left: 16px;
    border-left: 0.5px solid ${colors.NEUTRAL_2};
  }
`;

function IndicativeEquilibriumInfo(props) {
  const { code } = props;

  const {
    data: stockPriceIndicative,
    isFullCallAuction,
    isPreOpening,
    isPreClosing,
  } = stockService.detail.priceIndicative.usePriceIndicative(code);

  const shouldRender = isPreOpening || isPreClosing || isFullCallAuction;

  if (!shouldRender) {
    return null;
  }

  return (
    <Container padding="0px" marginTop="16px">
      <div className={styTitle}>
        <Typography type="body" bold my={0}>
          {isPreOpening && !isFullCallAuction && 'Prediksi Harga Pembukaan'}
          {isPreClosing && !isFullCallAuction && 'Prediksi Harga Penutupan'}
          {isFullCallAuction && 'Indicative Equilibrium Price/Volume'}
        </Typography>
        {!isFullCallAuction && (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                Prediksi harga hanya tersedia untuk saham LQ45, dan ditampilkan 15 menit sebelum
                bursa dibuka dan 15 menit sebelum bursa ditutup. Harga prediksi berasal dari sistem
                JATS yang dioperasikan oleh IDX.
              </Tooltip>
            }
          >
            <SvgIcon name="information" height={16} width={16} color={colors.AJAIB_BLUE_5} />
          </OverlayTrigger>
        )}
      </div>

      <div className={styContainer}>
        <div>
          <Typography type="body" display="inline" my={0} mr={4}>
            {isFullCallAuction ? 'IEP' : 'Harga'}
          </Typography>
          <Typography type="body" display="inline" bold my={0}>
            {decimalFormat(stockPriceIndicative?.opening_price)}
          </Typography>
        </div>
        <div>
          <Typography type="body" display="inline" my={0} mr={4}>
            {isFullCallAuction ? 'IEV' : 'Volume'}
          </Typography>
          <Typography type="body" display="inline" bold my={0}>
            {decimalFormat(stockPriceIndicative?.opening_qty)}
          </Typography>
        </div>
      </div>
    </Container>
  );
}

IndicativeEquilibriumInfo.propTypes = {
  code: string,
};

IndicativeEquilibriumInfo.defaultProps = {
  code: '',
};

export default IndicativeEquilibriumInfo;
